import { render, staticRenderFns } from "./GP2BrowserAssociationsPlot.vue?vue&type=template&id=cd08c83c&scoped=true&"
import script from "./GP2BrowserAssociationsPlot.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserAssociationsPlot.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserAssociationsPlot.vue?vue&type=style&index=0&id=cd08c83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd08c83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd08c83c')) {
      api.createRecord('cd08c83c', component.options)
    } else {
      api.reload('cd08c83c', component.options)
    }
    module.hot.accept("./GP2BrowserAssociationsPlot.vue?vue&type=template&id=cd08c83c&scoped=true&", function () {
      api.rerender('cd08c83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserAssociationsPlot.vue"
export default component.exports